import { render, staticRenderFns } from "./examinetasktopic.vue?vue&type=template&id=14ec2c4a&"
import script from "./examinetasktopic.vue?vue&type=script&lang=js&"
export * from "./examinetasktopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports